<template>
  <div>
    <b-table
      responsive
      :items="items"
      :fields="fields"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      no-local-sorting
      sort-icon-left
    >
      <template
        v-if="listFilters"
        #top-row="data"
      >
        <td
          v-for="(field,key) in data.fields"
          :key="key"
        >
          <list-column-filter
            v-if="field.key !=='action'"
            :name="field.key"
            :label="field.label"
            :filter="listFilters[field.key]"
            :value="filters[field.key]"
            @onFilterChange="( name, value)=> $emit('onFilterChange', name, value)"
          />
          <b-button
            v-else
            block
            variant="success"
            @click="$emit('onFilterButtonClicked')"
          >
            {{ $t("Search") }}
          </b-button>
        </td>
      </template>
      <!-- A custom formatted user column -->
      <template #cell(user)="data">
        <display-user :user="data.value" />
      </template>
      <!-- A custom formatted messages_count column -->
      <template #cell(messages_count)="data">
        {{ data.value | numberFormat }}/{{ data.item.extra_messages | numberFormat }}
      </template>
      <!-- A custom formatted payment_at column -->
      <template #cell(status)="data">
        <display-status
          :value="data.value"
          :text="data.item.display_status"
        />
      </template>
      <!-- A custom formatted expire_at column -->
      <template #cell(expire_at)="data">
        <display-date-time :value="data.value" />
      </template>
      <!-- A custom formatted action column -->
      <template #cell(action)="data">
        <b-button
          v-if="$can('update', 'services')"
          variant="flat-success"
          size="sm"
          class="btn-icon rounded-circle"
          @click="editButtonClicked(data.item)"
        >
          <feather-icon icon="Edit2Icon" />
        </b-button>
        <b-button
          v-if="$can('delete', 'services')"
          variant="flat-danger"
          size="sm"
          class="btn-icon rounded-circle"
          @click="deleteButtonClicked(data.item)"
        >
          <feather-icon icon="TrashIcon" />
        </b-button>
      </template>
    </b-table>
    <div
      v-if="!items.length"
      class="d-flex justify-content-center align-items-center"
    >
      <h6 class="font-weight-bolder mb-0">
        {{ $t("There are no services to display") }}
      </h6>
    </div>
    <services-edit-modal
      :form="editForm"
      :additional-data="additionalData"
      @onHideModal="resetEditForm"
      @onItemCreated="createdItem"
      @onItemUpdated="updatedItem"
    />
  </div>
</template>

<script>
import { ListTable } from '../../../common/mixins/list'
import ServicesEditModal from '../edit/ServicesEditModal'

export default {
  name: 'ServicesList',
  components: { ServicesEditModal },
  mixins: [ListTable],
  data() {
    return {
      routeName: 'services',
    }
  },
}
</script>

<style scoped>

</style>
